import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const partners = ['QuickBooks', 'Zillow', 'Apartments.com', 'DocuSign'];

const PartnersSection: React.FC = () => {
  return (
    <SectionBackground className="features" style={{ padding: '80px 16px' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 20, fontWeight: 700 }}>
          Future Integration Partners
        </h2>
        <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: '1.2rem', marginBottom: 60 }}>
          Coming soon: Seamless integrations with your favorite property management tools
        </p>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '40px',
          flexWrap: 'wrap',
        }}>
          {partners.map((partner, idx) => (
            <div
              key={idx}
              style={{
                width: '150px',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                color: 'var(--text-light)',
                fontWeight: 600,
                background: 'white',
                borderRadius: '8px',
              }}
            >
              {partner}
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default PartnersSection; 